export enum NewsPeriodicityType {
  None = 0,
  Daily = 1,
  Weekly = 2,
  Monthly = 3
}
